(ns app.front.view.workspace.map
  #_{:clj-kondo/ignore [:refer]} ; kondo doesn't understand shadow/npm requires
  (:require ["@cloudpermit/map-component" :refer (WorkspaceMap)]
            [app.front.view.system-of-units.toggle :as sou-toggle]
            [core.front.components :as components]
            [core.front.config :as front-config]
            [core.front.event :refer [<sub]]
            [core.front.i18n :as i18n]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]
            [reagent.core]))


(def map-icons (->> [["arrows" i/arrows]
                     ["chevron-down" i/chevron-down]
                     ["chevron-up" i/chevron-up]
                     ["circle-plus" i/plus]
                     ["circle-remove" i/remove]
                     ["download-map" i/download-map]
                     ["layers" i/layers]
                     ["map-marker-primary" i/map-marker-primary "rgb(79,8,145)"]
                     ["map-marker-selected" i/map-marker-primary "rgb(255,82,27)"]
                     ["measure" i/measure]
                     ["measure-area" i/measure-area]
                     ["viewfinder" i/viewfinder]
                     ["zoom-in" i/zoom-in]
                     ["zoom-out" i/zoom-out]
                     ["remove" i/remove]
                     ["square-foot" i/square-foot]
                     ["square-meter" i/square-meter]
                     ["draw" i/circle-pen]
                     ["add-point" i/add-point]
                     ["add-path" i/add-path]
                     ["add-circle" i/add-circle]
                     ["add-area" i/add-area]
                     ["select-point" i/select-point]]
                    (map (fn [[icon-name data color]]
                           {:class icon-name
                            :svg   (i/icon->img-svg-src data
                                                        color
                                                        false)}))
                    clj->js))

(def default-tool
  "Default tool is used for moving the map. In some cases
  it is also used to select drawn features for deletion."
  "DEFAULT")

(def measure-tool
  "Measure tool is used for measuring distances and areas on the map."
  "MEASURE")

(def layer-tool
  "Layer selection tool is used for selecting map layers."
  "LAYER_SELECT")

(def draw-tool
  "Draw tool is used for drawing points, lines, circles and polygons on the map.
  Usually the tool is hidden."
  "DRAW")

(def default-hidden-tools
  "By default, the draw tool is hidden."
  [draw-tool])

(def point-draw-tool
  "Point tool is used for drawing points on the map. Available under draw tool."
  "Point")

(def line-string-draw-tool
  "Line string tool is used for drawing lines on the map. Available under draw tool."
  "LineString")

(def circle-draw-tool
  "Circle tool is used for drawing circles on the map. Available under draw tool.
  Note that GeoJSON does not support circles directly, they are represented as polygons."
  "Circle")

(def polygon-draw-tool
  "Polygon tool is used for drawing polygons on the map. Available under draw tool."
  "Polygon")

(def modify-draw-tool
  "Modify tool is used for modifying existing drawn features on the map. Available under draw tool."
  "Modify")

(def default-hidden-draw-tools
  "By default, all draw sub-tools are hidden. Just hiding the main draw tool
  can leave the sub-tools visible."
  [point-draw-tool
   line-string-draw-tool
   circle-draw-tool
   polygon-draw-tool
   modify-draw-tool])

(rf/reg-event-db ::set-map-extended
  (fn [db [_ value]]
    (assoc db ::map-extended? value)))


(rf/reg-sub ::map-extended? :-> ::map-extended?)


(defn workspace-map [props]
  (let [extended-val (when (or (<sub [::map-extended?])
                               (:extended? props))
                       "extended")
        tr-fn        (<sub [:legacy-loc])
        full-locale  (<sub [::i18n/full-locale])
        sou          (<sub [::sou-toggle/default-system-of-units])
        country      (<sub [::front-config/country-kw])]
    [components/react-wrapper WorkspaceMap (merge {:hiddenTools     default-hidden-tools
                                                   ;; Ensure drawing sub-tools are not left visible
                                                   :hiddenDrawTools default-hidden-draw-tools}
                                                  props
                                                  {:mapConformation extended-val
                                                   :locFn           tr-fn
                                                   :icons           map-icons
                                                   :languageTag     full-locale
                                                   :units           sou
                                                   :country         country}
                                                  (when-not (:primaryMapMarkers props)
                                                    {:primaryMapMarkers [(:center props)]}))]))
